import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';
import { getLinkAcesso } from '../../produto/produtoActions';

class Menu extends Component {

	state = {
		acessoAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);

		this.props.getLinkAcesso();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLinkAcesso();
		}, 60000);
	}
	
	componentWillUnmount() {		
		clearInterval(this.idIntervalAtualizacao);
	}

	render() {

		const usuarioCarregado = this.props.usuarioCarregado;

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (selecionado != '/' 
			&& this.state.acessoAberto == null
			&& this.state.cadastroAberto == null
		) {
			if (selecionado == '/usuarioPerfil' || selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			}
		}		
		
		return (
			<nav className="mt-2">

				{usuarioCarregado &&			    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					{/* <MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} /> */}
					
					{(this.props.getPermissao('cadastro_perfil') || this.props.getPermissao('cadastro_usuario')) &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						{/*this.props.getPermissao('cadastro_perfil') &&
						<MenuItem submenu path='usuarioPerfil' label='Perfil' icon='fas fa-list' active={selecionado == '/usuarioPerfil'} />*/}
						{this.props.getPermissao('cadastro_usuario') &&
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />}
					</MenuTree>}

					{this.props.getPermissao('cadastro_usuario') &&
					<MenuItem submenu path='grupoProduto' label='Grupos de Produtos' icon='fas fa-list-alt' active={selecionado == '/grupoProduto'} />}

					{this.props.getPermissao('pedido') &&
					<MenuItem path='produto' label='Produto' icon='fas fa-list-ol' active={selecionado == '/produto'} />}

					{this.props.getPermissao('cadastro_geral') &&
					<MenuItem path='cliente' label='Cliente' icon='fas fa-users' active={selecionado == '/cliente'} />}
					
					{this.props.getPermissao('pedido') &&
					<MenuItem path='pedido' label='Pedido Aberto' icon='fas fa-clipboard-list' active={selecionado == '/pedido' || selecionado == '/'} />}

					{this.props.getPermissao('pedido') &&
					<MenuItem path='pedidoHistorico' label='Pedido Fechado' icon='fas fa-clipboard-check' active={selecionado == '/pedidoHistorico'} />}

					{this.props.linkCatalogoComPreco &&
					<li class='nav-item'>
						<a class='nav-link' href={this.props.linkCatalogoComPreco} target='blank'>
							<i class='nav-icon fas fa-tags'></i><p>Catálogo com Preço<span class='badge badge-undefined right'></span></p>
						</a>
					</li>}

					{this.props.linkCatalogoSemPreco &&
					<li class='nav-item'>
						<a class='nav-link' href={this.props.linkCatalogoSemPreco} target='blank'>
							<i class='nav-icon fas fa-book-open'></i><p>Catálogo sem Preço<span class='badge badge-undefined right'></span></p>
						</a>
					</li>}
				</ul>}
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	getPermissao: state.auth.getPermissao,
	linkCatalogoComPreco: state.produto.linkCatalogoComPreco,
	linkCatalogoSemPreco: state.produto.linkCatalogoSemPreco
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario, getLinkAcesso }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
